// Connecting styles
import "../styles/index.scss";
import React from "react";
import {createRoot} from "react-dom/client";
import StoreLocatorApp from "./StoreLocatorApp";
import {BrowserRouter} from "react-router";
import {ErrorBoundary} from "react-error-boundary";
import ErrorFallback from "./components/ErrorFallback";

// Importing necessary images/icons
import "../images/pawIcon.svg";
import {Provider} from "react-redux";
import BilJacAppStore from "./store";

// Initializing the app
document.addEventListener("DOMContentLoaded", () => {

    const storeLocatorRootEl = document.querySelector<HTMLDivElement>(".blj-store-locator-root");
    if (storeLocatorRootEl) {

        const storeLocatorRoot = createRoot(storeLocatorRootEl);
        storeLocatorRoot.render(
            <Provider store={BilJacAppStore}>
                <BrowserRouter>
                    <ErrorBoundary
                        fallbackRender={
                            ({error}) => (
                                <ErrorFallback
                                    error={error}
                                    resetErrorBoundary={() => window.location.reload()}
                                />
                            )}
                    >
                        <StoreLocatorApp/>
                    </ErrorBoundary>
                </BrowserRouter>
            </Provider>
        );

    }

});